import { useLocation } from 'react-router-dom';
import { LinkStripeAccountDto } from '../../types/stripe';
import useGetStripeAccount from './useGetStripeAccount';
import { ROUTES } from '../../constants/global';
import useStripeAccountActions from './useStripeAccountActions';

interface UseStripeSetupProps extends Partial<LinkStripeAccountDto> {
  enabled?: boolean;
}

const useStripeSetUp = ({
  refreshUrl,
  returnUrl,
  enabled = true,
}: UseStripeSetupProps = {}) => {
  const { pathname } = useLocation();

  const autoRefetch = pathname.includes(ROUTES.payments);

  const { isLoading, isFetching, data, refetch } = useGetStripeAccount({
    refetchOnWindowFocus: autoRefetch,
    refetchOnReconnect: autoRefetch,
    refetchOnMount: autoRefetch,
    enabled,
  });

  const { isLinking, isGettingLogin, onStartSetup, onViewStripeAccount } =
    useStripeAccountActions({
      refreshUrl,
      returnUrl,
    });

  return {
    data,
    refetch,
    isLoading,
    isFetching,
    isLinking,
    isGettingLogin,
    onStartSetup,
    onViewStripeAccount,
  };
};

export default useStripeSetUp;
